import React from 'react';
import './SubscribeSection.css';
import Button from '../Button/Button';

export default function SubscribeSection() {
  return (
    <section className="subscribe-section">
      <div className="subscribe-inner">
        <div className="subscribe-copy">
          <h3>Subscribe to our newsletter</h3>
          <p>
            Stay in touch with updates and news from scope console.
          </p>
        </div>

        <form
          className="subscribe-form"
          onSubmit={(e) => e.preventDefault()}
        >
          <input
            type="email"
            placeholder="Email address"
            aria-label="Email address"
          />
          <Button>Sign up</Button>
        </form>
      </div>
    </section>
  );
}
